import { useAppDispatch } from "../../../../../redux/hooks";

import CustomButton from "../../../../../components/CustomButton";

import { DevicesNomenclatureListInterface } from "../../../../../redux/interfaces/admin.interface";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { getDownloadDevice } from "../../../../../redux/api/admin.api";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function DevicesNomenclatureHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: DevicesNomenclatureListInterface;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const handleDownloadDevice = async () => {
    if (itemId) {
      await dispatch(getDownloadDevice({ idDevice: itemId }));
    }
  };

  return (
    <div>
      {isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE) && (
        <>
          {crudData.url && (
            <CustomButton
              variant="contained"
              tooltipTitle="Download"
              className="mt-1 me-1"
              onClick={handleDownloadDevice}>
              <SvgIcon type="DOWNLOAD" />
            </CustomButton>
          )}
        </>
      )}
    </div>
  );
}

export default DevicesNomenclatureHistoryActionButtons;
